module.exports = __webpack_public_path__ + "static/img/655d836e7c89f6993fe4cf05_X-examples-of-AI-generated-content_blog-listing-768x614.75f195ae.png";